import { ToastType } from '../ToastProvider/types';

export const INFO = 'info';
export const DEFAULT = 'default';
export const ERROR = 'error';
export const ALERT = 'alert';
export const CONFRIMATION = 'confirmation';

export type ToastStyleTaype = 'info' | 'confirmation' | 'error' | 'alert' | 'default';
export type ToastIconTaype = 'information-circle' | 'x-circle' | 'exclamation' | 'check-circle';

export type ToastPropsType = {
  index: number;
  toast: ToastType;
  toasts: ToastType[];
  deleteToast: () => void;
};

export interface TypeToastIcon {
  [key: string]: ToastIconTaype;
}
export const ToastIcon: TypeToastIcon = {
  [INFO]: 'information-circle',
  [DEFAULT]: 'information-circle',
  [ERROR]: 'x-circle',
  [ALERT]: 'exclamation',
  [CONFRIMATION]: 'check-circle',
};
